export default __webpack_public_path__ + "static/three-women-phone-9bd1b8c6d1a348d94d990f349b7c7ff2.png";